import styled from "styled-components";

const GuideText = styled.p<{color?: string; marginTop?: boolean;}>`
	position: relative;
	font-size: var(--basic-size);
	padding-left: 12px;
	margin-top: ${props => props.marginTop ? '15px' : ''};
	color: ${props => props.color ? props.color : 'var(--default-color)'};

	&::before {
		position: absolute;
		top: 8px;
		left: 0;
		display: block;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background: var(--bl-color);
		content: "";
	}
`;

export default GuideText;